import colors from '../../../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    
    return {
        contentWrapper: {
            backgroundColor: colors[mode].secondaryBackground,
            display: 'flex',
            flex: 1,            
            flexDirection: 'column',
            justifyContent: 'center',
        },
        footer: {
            padding: '0% 3%',
            width: '100%'
        },
        gridContainerCenter: {
            backgroundColor: colors[mode].secondaryBackground,
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'center',
            padding: '3% 0% 5% 0%',
            width: '100%',
            [theme.breakpoints.down('md')]: {
                padding: '5% 5%'
            },
            [theme.breakpoints.down('sm')]: {
                gridTemplateColumns: '1fr',
                padding: '4% 4%'
            },
            [theme.breakpoints.down('xs')]: {
                gridTemplateColumns: '1fr',
                padding: '3% 3%'
            }
        },
        gridContainerError: {
            backgroundColor: colors[mode].secondaryBackground,
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
        },
        linearProgress: {
            left: 0,
            position: 'fixed',
            top: '72px',
            width: '100%',
            zIndex: -1,
            [theme.breakpoints.down('sm')]: {
                top: '56px'
            }
        },
        pageWrapper: {
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '100vw',
            minHeight: '100vh',
            overflow: 'hidden',            
        }

    }
}